import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCreditCardData(selectedCompanyId?: number) {
    const { data: creditCards, isLoading: isLoadingCreditCards } = useQuery({
        queryKey: [QueryKey.COMPANY_CREDIT_CARDS, selectedCompanyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.credit-cards.get', selectedCompanyId));
            return data;
        },
        placeholderData: [],
        enabled: !!selectedCompanyId,
    });

    return {
        creditCards,
        isLoadingCreditCards,
    };
}
